module.exports = __webpack_public_path__ + "static/media/IKMS10.fd45cb67.jpg";